/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ClaimApiConfiguration {
  rootUrl: string = '/';
}

/**
 * Parameters for `ClaimApiModule.forRoot()`
 */
export interface ClaimApiConfigurationParams {
  rootUrl?: string;
}
